import axios from 'axios';
import requestCatchError from './requestCatchError';

const clientExternal = axios.create();

const request = async (method, path, body = null, params = {}) => {
  try {
    const response = await clientExternal[method](path, body, params);
    return response;
  } catch (error) {
    return requestCatchError(error);
  }
};

const apiExternal = {
  get: (path, params) => request('get', path, params),
  post: (path, body, params) => request('post', path, body, params),
  patch: (path, body) => request('patch', path, body),
  put: (path, body) => request('put', path, body),
  delete: (path, params) => request('delete', path, params),
};

export default apiExternal;
